document.addEventListener('DOMContentLoaded', function () {
	var triggers = document.querySelectorAll('[data-modal]');
	var modal = document.getElementById('flexi-modal');
	var modal_background = document.getElementById('flexi-modal-background');
	var modal_close = document.getElementById('flexi-modal-close');
	var modal_iframe = document.getElementById('flexi-modal-iframe');
	let page = document.getElementById('main');

	let trap_interval = false;

	let trap = false;

	if (modal) {
		//if we've not initialized the focus trap
		if (!trap) {
			const focusTrap = require('focus-trap');
			trap = focusTrap.createFocusTrap(modal);
		}

		triggers.forEach(function (trigger) {
			trigger.addEventListener('click', function (event) {
				openModal(event, trap);
			});
		});

		document.addEventListener('keydown', function (event) {
			if (event.key === 'Escape' && !modal_iframe.classList.contains('hidden')) {
				closeModal(trap);
			}
		});

		modal_close.addEventListener('click', function (e) {
			closeModal(trap);
		});

		modal_background.addEventListener('click', function (e) {
			closeModal(trap);
		});
	}

	function openModal(theTrigger, trap) {
		/**
		 * Hide unnecessary padding
		 */
		var the_video = '';
		if (theTrigger.target) {
			the_video = theTrigger.target.getAttribute('data-video');
		} else {
			the_video = theTrigger.getAttribute('data-video');
		}

		if (the_video) {
			modal_iframe.classList.remove('hidden');
		}

		modal_iframe.innerHTML = the_video;

		//attempt to isolate the video URL
		let video_url = the_video.match(/\bhttps?:\/\/\S+/gi)[0];

		//if we have a URL
		if (video_url) {
			//append a screen reader button to allow proper iframe tabbing
			modal_iframe.innerHTML =
				modal_iframe.innerHTML +
				'<a href="' +
				video_url +
				'" target="_blank" class="sr-only">Watch ' +
				(video_url.includes('youtube')
					? 'on YouTube'
					: video_url.includes('vimeo')
					? 'on Vimeo'
					: 'online') +
				'</a>';
		}

		page.style.overflow = 'hidden';

		modal.classList.remove('invisible');
		modal.classList.remove('opacity-0');

		if (the_video) {
			modal_iframe.focus();
		} else {
			modal_content.focus();
		}


		//attempt to trigger focus trap
		let trap_status = triggerModalTrap(trap);

		//if the trap wasn't set
		if (!trap_status) {
			//set an interval to attempt this every 2s
			trap_interval = setInterval(triggerModalTrap, 2000, trap);
		}
	}

	function triggerModalTrap(trap) {
		//if the cookie popup has already been and interacted with
		if (
			document.cookie.match(
				/^(.*;)?\s*cookiesAcknowledged\s*=\s*[^;]+(.*)?$/
			)
		) {
			setTimeout(function () {
				//activate the trap
				trap.activate();

				//stop future intervals occuring
				clearInterval(trap_interval);

				//indicate the trap is active
				return true;
			}, 100);
		}

		//otherwise indicate the trap isn't active
		return false;
	}

	function closeModal(trap) {
		modal.classList.add('invisible', 'opacity-0');
		page.style.overflow = '';
		modal_iframe.innerHTML = '';
		modal_iframe.classList.add('hidden');
		trap.deactivate();
	}

});
